module.exports = __webpack_public_path__ + "static/media/black-shirt-casual.b60a5e61.jpg";